import React, { Component } from "react";

class ApplyTopBrand extends Component {
  render() {
    return <div>ApplyTopBrand</div>;
  }
}

export default ApplyTopBrand;
